
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial-policy",
      function () {
        return require("private-next-pages/editorial-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorial-policy"])
      });
    }
  